export default __webpack_public_path__ + "static/media/libertarian-banner-logo.fa8fec7a.png";